import styled from "styled-components";

export const RefererTyCStl = styled.div`
   padding: 20px 15%;
   h3{
      text-align: center;
      margin-bottom: 50px;
   }

   bold{
      font-weight: bold;
   }
`